import React from 'react'

export const SkillItem = ({ white, src, skill }) => {
  return (
    <div className="skill-item">
      <img style={{ filter: white ? 'invert(100%)' : '' }} src={`/skills/${src}.png`} alt="skill" className='skillLogo' />
      <div className='skillLabel'>
        <h4>{skill}</h4>
      </div>
    </div>
  )
}
